module.exports = __webpack_public_path__ + "static/kardos-410cdf3c2d201db59db0c6c25311eaed.png";